var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackicon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5204 12.2321L0.280277 7.03961C-0.100822 6.61088 -0.100821 6.22978 0.327915 5.84868L5.5204 0.656197C6.33023 0.22746 6.85425 0.322734 6.94952 1.56131L6.90188 5.46758H14.5738C15.1455 5.46758 15.5742 5.89632 15.5742 6.46797C15.5742 6.99198 15.1455 7.46835 14.5738 7.46835H6.85425V11.4699C6.75897 12.5656 6.33023 12.899 5.5204 12.2321Z",
    fill: "#CD1479"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackicon);
export default __webpack_public_path__ + "static/media/backicon.2809ab5cbfcade3917966fb72df8dc96.svg";
export { ForwardRef as ReactComponent };